import React from 'react';
import { CONNECTION_TYPE, ConnectionFormVM } from '../connection-form.viewmodel';
import { ConnectionType } from '../../../../../../../api/connections.dao';
import { FieldsWrapper } from '../connection-form-fields-wrapper/connection-form-fields-wrapper';
import { AudioBridgeConnectionFormBody } from './audio-bridge-connection-form/audio-bridge-connection.form-body';
import { AudioBridgeConnectionFormVm } from './audio-bridge-connection-form/audio-bridge-connection.form-vm';
import { PanelistLinkConnectionFormVm } from './panelist-link-connection-form/panelsit-llink-connection.form-vm';
import { PanelistLinkConnectionFormBody } from './panelist-link-connection-form/panelist-link-connection.form-body';

export type ConnectionFormBodyProps = {
    formVM: ConnectionFormVM;
};

export const ConnectionFormBody = (props: ConnectionFormBodyProps): JSX.Element => {
    const { formVM } = props;

    switch (formVM[CONNECTION_TYPE]) {
        case ConnectionType.AudioBridge:
            return <AudioBridgeConnectionFormBody
                isMeetingForm={formVM.isMeetingConnectionsForm || !!formVM.meetingApiParams.meetingId}
                vm={formVM.getConnectionFormDataVM() as AudioBridgeConnectionFormVm}
                formVM={formVM}
            />;
        case ConnectionType.PanelistLink:
            return <PanelistLinkConnectionFormBody
                vm={formVM.getConnectionFormDataVM() as PanelistLinkConnectionFormVm}
            />;
        default:
            return <FieldsWrapper formVM={formVM} />;
    }
};
